export const PDF_THEME = {
  page: {
    width: '210mm',
    minHeight: '297mm',
    padding: {
      compact: '10mm 9mm 8mm 9mm',
      standard: '14mm 12mm 10mm 12mm',
    },
  },
  font: {
    family: 'Arial, Helvetica, "DejaVu Sans", sans-serif',
  },
};

export function getPdfLayoutConfig(settings = {}) {
  const density = settings?.pdfDensity === 'compact' ? 'compact' : 'standard';
  const template = settings?.pdfTemplate === 'clean' ? 'clean' : 'classic';
  return {
    density,
    template,
    pagePadding: PDF_THEME.page.padding[density],
    tableHeaderClass:
      template === 'clean'
        ? 'flex w-full text-[9px] font-semibold text-slate-800 rounded-t-lg overflow-hidden border border-slate-200 bg-slate-100'
        : 'flex w-full text-[9px] font-bold text-white rounded-t-lg overflow-hidden',
  };
}
